/**
 * 出品アイテムステータス
 */
export const BiddingDisplayConditionConst = {
  /**
   * 全件
   */
  ALL: 1,
  /**
   * 入札済
   */
  BIDDING: 2,
} as const; // 'as const' が型を固定します (read-only になる)
export type BiddingDisplayConditionType = typeof BiddingDisplayConditionConst[keyof typeof BiddingDisplayConditionConst];